/**
 * Reduz a foto antes de guardar e enviar: celular tira 4–8 MB, o limite da API é
 * 8 MB e o 4G do pátio não perdoa. Lado maior em 1600 px e JPEG 0,82 mantêm a
 * avaria legível com ~300 KB.
 *
 * Qualquer falha (HEIC que o navegador não decodifica, sem canvas) devolve o
 * ARQUIVO ORIGINAL — comprimir é otimização, nunca motivo para perder a foto.
 */
export const MAX_SIDE = 1600;
export const JPEG_QUALITY = 0.82;

/** Dimensões finais respeitando o lado máximo, sem ampliar. */
export function targetSize(width: number, height: number, max = MAX_SIDE): { width: number; height: number } {
  const maior = Math.max(width, height);
  if (maior <= max) return { width, height };
  const k = max / maior;
  return { width: Math.round(width * k), height: Math.round(height * k) };
}

export async function compressPhoto(file: Blob): Promise<Blob> {
  try {
    if (typeof createImageBitmap !== "function" || typeof document === "undefined") return file;
    const bmp = await createImageBitmap(file);
    const { width, height } = targetSize(bmp.width, bmp.height);
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d")!.drawImage(bmp, 0, 0, width, height);
    bmp.close?.();
    const out = await new Promise<Blob | null>((ok) => canvas.toBlob(ok, "image/jpeg", JPEG_QUALITY));
    // Nunca troca por algo maior (foto já pequena, PNG de print).
    return out && out.size < file.size ? out : file;
  } catch {
    return file;
  }
}
